
export default function PageHeader({ header }) {
	return (
		<>
			<span className='page_header'>{header}</span>
            
		</>
	);
}
